import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { AuthorizationApplicationEvent } from '~shared/modules/application-event/models';
import {
  ApplicationAuthorizationActionType,
  AssistedSalesActionType,
  ImpersonationEventsLabel,
} from '~shared/modules/application-event/constants';
import { Injectable } from '@angular/core';
import { AssistedSalesApplicationEvent } from '~shared/modules/application-event/models/assisted-sales-application-event.model';

@Injectable({
  providedIn: 'root',
})
export class EmployeeGaTrackingService {
  constructor(private applicationEventService: ApplicationEventService) {}

  gaTrackingEmployeeLogout() {
    this.applicationEventService.publish(
      new AuthorizationApplicationEvent(
        ApplicationAuthorizationActionType.DestinationLogin,
        ImpersonationEventsLabel.EmployeeLogoutSuccess
      ),
      true
    );
  }
  gaTrackingImpersonationLogout() {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationLogin,
        ImpersonationEventsLabel.ImpersonationLogoutSuccess
      ),
      true
    );
  }
  gaTrackingImpersonationLogin() {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationLogin,
        ImpersonationEventsLabel.ImpersonationLoginSuccess
      ),
      true
    );
  }
  gaTrackingOrderHistoryEvent() {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationOrderHistory,
        ImpersonationEventsLabel.ImpersonationOrderHistory
      ),
      true
    );
  }
  gaTrackingProceedToCheckoutSuccessEvent() {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationProceedToCheckout,
        ImpersonationEventsLabel.ImpersonationProceedToCheckoutSuccess
      ),
      true
    );
  }
  gaTrackingProceedToCheckoutFailEvent() {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationProceedToCheckout,
        ImpersonationEventsLabel.ImpersonationProceedToCheckoutFail
      ),
      true
    );
  }
  gaTrackingShareLinkEvent() {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationShareLink,
        ImpersonationEventsLabel.ImpersonationShareLink
      ),
      true
    );
  }
  gaTrackingDigitalAccountCreationSucessEvent() {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationDigitalAccountCreation,
        ImpersonationEventsLabel.ImpersonationDigitalAccountSuccess
      ),
      true
    );
  }
  gaTrackingDigitalAccountCreationErrorEvent() {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationDigitalAccountCreation,
        ImpersonationEventsLabel.ImpersonationDigitalAccountError
      ),
      true
    );
  }
  gaTrackingPaymentLinkSharedSuccessEvent(employeeId: string, sharedPaymentLinkId: string) {
    this.applicationEventService.publish(
      new AssistedSalesApplicationEvent(
        AssistedSalesActionType.ImpersonationPaymentLinkShared,
        ImpersonationEventsLabel.ImpersonationPaymentLinkShareSuccess,
        employeeId,
        sharedPaymentLinkId
      ),
      true
    );
  }
}
